<script lang="ts">
	interface Props {
		height?: string; // Default height
		width?: string; // Default width
		class?: string;
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props();
	
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	fill="none"
	viewBox="0 0 48 48"
	{height}
	{width}
	class={className}
	><path
		d="m22.836 24 4.58 4.588 -2.832 2.824 -9.412 -9.43 9.414 -9.4 2.828 2.832L22.82 20H38V6a4 4 0 0 0 -4 -4H12a4 4 0 0 0 -4 4v32a4 4 0 0 0 4 4h22a4 4 0 0 0 4 -4v-14z"
		fill="currentcolor"
		stroke-width="1"
	/></svg
>
